import React, { Component } from 'react';
import { Link } from "react-router-dom";

export default class Demo extends Component {
	render() {
		return <section className="main">
                <div className="Lmt10">
                    <Link to="/" className="btn btn-primary btn-large">
                        去首页
                    </Link>
                    <Link to="/icons" className="btn btn-default btn-large Lmt10">
                        Icons
                    </Link>
                    <Link to="/dialog" className="btn btn-default btn-large Lmt10">
                        弹窗
                    </Link>
                    <Link to="/swiper" className="btn btn-default btn-large Lmt10">
                        轮播
                    </Link>
                </div>
			</section>;
	}
}



// WEBPACK FOOTER //
// ./src/components/Demo/Demo.js